import React from "react";
import { Route, Switch } from "react-router-dom";
import { Rules } from "./pages";

export const Distribution = function () {
  return (
    <Switch>
      <Route exact path="/app/rules" component={Rules} />
    </Switch>
  );
};

export default Distribution;
